import * as components from './components'

export default [
  {
    path: '/shipment',
    name: 'shipment',
    component: components.shipmentDocuments
  }
]
